import React, { Component } from 'react';
import _ from 'lodash';
import cx from 'classnames';
import { withViewModelService, ViewModelForm } from 'gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { withValidation, validationPropTypes } from 'gw-portals-validation-react';
import { TranslatorContext } from '@jutro/locale';
import PaymentStyles from './PaymentComponent.module.scss';
import metadata from './PaymentComponent.metadata.json5';
import messages from './PaymentComponent.messages';

const accountNumberRegix = new RegExp('^[0-9]*$');

class PaymentComponent extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        model: PropTypes.shape({
            paymentMethod: PropTypes.string,
            bankAccountData: PropTypes.shape({})
        }),
        viewModelService: PropTypes.shape({
            create: PropTypes.func
        }).isRequired,
        onCallbackTransaction: PropTypes.func.isRequired,
        onCallbackCancelTransaction: PropTypes.func.isRequired,
        xCenter: PropTypes.string.isRequired,
        title: PropTypes.shape({
            id: PropTypes.string.isRequired,
            defaultMessage: PropTypes.string.isRequired
        }).isRequired,
        nextLabel: PropTypes.shape({
            id: PropTypes.string.isRequired,
            defaultMessage: PropTypes.string.isRequired
        }),
        previousLabel: PropTypes.shape({
            id: PropTypes.string.isRequired,
            defaultMessage: PropTypes.string.isRequired
        }),
        isCustomFooter: PropTypes.bool,
        bankAccountPaymentInstrument: PropTypes.shape({
            paymentMethod: PropTypes.string,
            bankAccountData: PropTypes.shape({})
        }),
        isFormVisible: PropTypes.bool,
        updateTnCAccepted: PropTypes.func.isRequired,
        isTnCAccepted: PropTypes.bool,
        ...validationPropTypes
    };

    static defaultProps = {
        model: undefined,
        nextLabel: undefined,
        previousLabel: undefined,
        isCustomFooter: false,
        bankAccountPaymentInstrument: undefined,
        isTnCAccepted: false,
        isFormVisible: true
    }

    constructor(props) {
        super(props);
        this.state = {
            accountBankDetailVM: {}
        };
    }

    componentDidMount = () => {
        let { accountBankDetailVM } = this.state;
        const {
            viewModelService, xCenter, model
        } = this.props;
        const initValue = {
            paymentMethod: '',
            bankAccountData: {}
        };

        const mergedModel = Object.assign({}, initValue, model);
        let { bankAccountData: bankDetailsModel } = mergedModel;
        if (_.isEmpty(bankDetailsModel)) {
            bankDetailsModel = {
                bankAccountType: 'checking'
            };
        }

        accountBankDetailVM = viewModelService.create(
            bankDetailsModel,
            xCenter,
            'edge.capabilities.billing.dto.AccountBankDetailsDTO'
        );
        this.setState({
            accountBankDetailVM
        });
    };

    componentDidUpdate(prevProps) {
        const { bankAccountPaymentInstrument, isFormVisible } = this.props;
        if ((!_.isEmpty(bankAccountPaymentInstrument)
        && bankAccountPaymentInstrument !== prevProps.bankAccountPaymentInstrument)
        || (prevProps.isFormVisible !== isFormVisible)) {
            this.setBankDetails();
        }
    }

    isModelValid = (viewModel) => {
        return viewModel.aspects
            ? viewModel.aspects.valid && viewModel.aspects.subtreeValid
            : false;
    };

    maskAccountNumber = (evnt, acctNumber) => {
        const accNum = acctNumber.value;
        const maskedAccountNumber = this.getMaskedAccountNumber(accNum);
        const { accountBankDetailVM } = this.state;
        _.set(accountBankDetailVM, 'value.maskedBankAccountNumber_TDIC', maskedAccountNumber);
        _.set(accountBankDetailVM, 'value.bankAccountNumber', accNum);
        if (accNum === undefined || !accNum.startsWith('*')) {
            _.set(accountBankDetailVM, 'value.bankAccountNumber', accNum);
        }

        this.setState({
            accountBankDetailVM
        });
    };


    updateMaskedAccountNumber = (value) => {
        const { accountBankDetailVM } = this.state;
        const acountNumb = _.get(accountBankDetailVM, 'value.maskedBankAccountNumber_TDIC');
        if (accountNumberRegix.test(value) || acountNumb.length - 1 === value.length) {
            _.set(accountBankDetailVM, 'value.maskedBankAccountNumber_TDIC', value);
            this.setState({
                accountBankDetailVM
            });
        }
    };

    writeValue = (value, path) => {
        const { accountBankDetailVM } = this.state;
        _.set(accountBankDetailVM, path, value);
        this.setState({ accountBankDetailVM });
    };

    checkBoxValue = () => {
        const { accountBankDetailVM } = this.state;
        if (_.isUndefined(accountBankDetailVM.checkBoxDetails)) {
            _.set(accountBankDetailVM, 'checkBoxDetails', false);
        }
        return accountBankDetailVM.checkBoxDetails;
    };

    getMaskedAccountNumber = (accountNumber) => {
        if (accountNumber !== undefined && accountNumber.length >= 4) {
            return `*${accountNumber.substring(accountNumber.length - 4)}`;
        }
        return accountNumber;
    };

    setBankDetails = () => {
        const { bankAccountPaymentInstrument, xCenter, viewModelService } = this.props;
        const cloneAccountBankDetailVM = viewModelService.create(
            _.get(bankAccountPaymentInstrument, 'bankAccountData', { bankAccountType: 'checking' }),
            xCenter,
            'edge.capabilities.billing.dto.AccountBankDetailsDTO'
        );
        const acctNumber = _.get(cloneAccountBankDetailVM, 'value.bankAccountNumber');
        const maskedNumber = this.getMaskedAccountNumber(acctNumber);
        _.set(cloneAccountBankDetailVM, 'value.maskedBankAccountNumber_TDIC', maskedNumber);
        this.setState({
            accountBankDetailVM: cloneAccountBankDetailVM
        });
    }

    payNowClicked = () => {
        const { onCallbackTransaction } = this.props;
        const { accountBankDetailVM } = this.state;

        if (onCallbackTransaction) {
            const paymentMethodCode = 'ach';
            onCallbackTransaction(accountBankDetailVM, paymentMethodCode);
        }
    };

    handlePrint = () => {
        window.print();
    };

    render() {
        const translator = this.context;
        const {
            accountBankDetailVM,
            showValidationErrors,
        } = this.state;
        const {
            title, nextLabel, previousLabel, onCallbackCancelTransaction, isCustomFooter,
            setComponentValidation,
            isFormVisible,
            isTnCAccepted, updateTnCAccepted
        } = this.props;
        const isComponentValid = isFormVisible
            ? (this.isModelValid(accountBankDetailVM) && isTnCAccepted) : isTnCAccepted;

        const overrides = {
            payNow: {
                onClick: this.payNowClicked,
                content: translator(nextLabel),
                disabled: !isComponentValid
            },
            bankAccountContainer: {
                visible: isFormVisible
            },
            paymentOptionsTitle: {
                content: translator(title)
            },
            cancel: {
                content: translator(previousLabel) || translator(messages.cancel)
            },
            buttonContainer: {
                className: cx(PaymentStyles.paymentButtonFooter, {
                    [PaymentStyles.paymentCustomFooter]: isCustomFooter
                })
            },
            termsOfUseCheckbox: {
                label: isFormVisible ? messages.tncLabelAutopay : messages.tncLabel,
                onValueChange: updateTnCAccepted,
                value: isTnCAccepted
            },
            printButton: {
                visible: isFormVisible
            }
        };

        const resolvers = {
            resolveClassNameMap: PaymentStyles,
            resolveCallbackMap: {
                onCancel: onCallbackCancelTransaction,
                handlePrint: this.handlePrint,
                maskAccountNumber: this.maskAccountNumber,
                updateMaskedAccountNumber: this.updateMaskedAccountNumber
            }
        };

        const readValue = (id, path) => {
            return readViewModelValue(metadata.componentContent,
                accountBankDetailVM, id, path, overrides);
        };

        return (
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={accountBankDetailVM}
                showErrors={showValidationErrors}
                overrideProps={overrides}
                resolveValue={readValue}
                onValidationChange={setComponentValidation}
                onValueChange={this.writeValue}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
            />
        );
    }
}

export default withValidation(withAuthenticationContext(
    (withViewModelService(PaymentComponent))
));
